import { useQuery } from '@tanstack/react-query';
import { UpdateToEventBatchBootstrapView, UpdateToEventQueryResult } from '@mark43/cad-api';
import useUpdateToEventResource from './use-update-to-event-resource';

export const useDexMessageBootstrap = ({
    dexMessageId,
    eventId,
    isSummaryView,
    enabled = true,
    onError,
}: {
    dexMessageId?: number;
    eventId?: number;
    isSummaryView?: boolean;
    enabled?: boolean;
    onError?: () => void;
}) => {
    const { getUpdateToEventBootstrap } = useUpdateToEventResource();

    return useQuery<UpdateToEventBatchBootstrapView | undefined>(
        ['dex-message-bootstrap', dexMessageId, eventId, isSummaryView],
        async () => {
            if (dexMessageId === undefined) {
                return undefined;
            }
            const result = await getUpdateToEventBootstrap({
                eventId,
                dexIncomingMessageId: isSummaryView ? undefined : dexMessageId,
                outgoingMessageId: isSummaryView ? dexMessageId : undefined,
            });
            const legacyView = result.data?.data;
            if (!legacyView) {
                return undefined;
            }

            // Transform legacy response into batch format for uniform consumption
            const queryResult: UpdateToEventQueryResult = {
                queryId: `${dexMessageId}`,
                showUpdateToEventButton: legacyView.showUpdateToEventButton,
                eventPersons: legacyView.eventPersons,
                eventVehicles: legacyView.eventVehicles,
                matchingEventPerson: legacyView.matchingEventPerson,
                matchingEventVehicle: legacyView.matchingEventVehicle,
                parsedPerson: legacyView.parsedPerson,
                parsedVehicle: legacyView.parsedVehicle,
            };

            return {
                eventAutocompleteView: legacyView.eventAutocompleteView,
                updateToEventQueryResults: [queryResult],
            };
        },
        {
            enabled: enabled && dexMessageId !== undefined,
            cacheTime: 0,
            staleTime: 0,
            retry: 2,
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            onError: () => onError?.(),
        }
    );
};
